import { Component, ViewChild,ElementRef} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { ActionSheetController } from '@ionic/angular';
import { NativeService } from '../../../../service/native.service';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { WxjssdkService } from 'src/service/wxjssdk.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;

@Component({
  selector: 'app-a2-price-check',
  templateUrl: './a2-price-check.component.html',
  styleUrls: ['./a2-price-check.component.scss']
})
export class A2PriceCheckComponent extends GridBaseCase {
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  dataArrayList: Array<any> = [];
  submitArray: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  imgUrlArr:any = [];//照片数组
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private actionSheet: ActionSheetController,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public weixin:WxjssdkService,
    public nativeService: NativeService
  ) { super(); }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    let that = this;
    // console.log(that.element);
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.dataArrayList = [];
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else {
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item,i) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.baseService.arrayData.push(objfield);
          let _imgObj = {};
          let childImgUrlArr = [];
          if(objfield['photo'].value){
            const imgArr = objfield['photo'].value.split(",");
            imgArr.forEach((item)=>{
              _imgObj = {
                name:item,
                url:(app.FileUoloadUrl + item).replace(app.ImagePlaceholder,app.SmallImageType)
              }
              childImgUrlArr.push(_imgObj);
            })
          }

          that.imgUrlArr.push({"childImgUrl":childImgUrlArr});
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  /**
   * 拍照
   */
  getCamera(i){
    let that = this;
    if(that.com.IsWeixinBrowser){
      that.weixin.GetWxCamera().then(data=>{
        let _url:string= (app.FileUoloadUrl + data.Status[0].FileName).replace(app.ImagePlaceholder,app.SmallImageType);
        let _obj = {url:_url,name:data.Status[0].FileName};
        that.imgUrlArr[i]["childImgUrl"].push(_obj);
        let submitImgUrl = "";
        that.imgUrlArr[i]["childImgUrl"].forEach((item)=>{
          if(submitImgUrl == ""){
            submitImgUrl += item.name;
          }else{
            submitImgUrl += ',' + item.name;
          }
        });
        that.baseService.arrayData[i]["photo"].value = submitImgUrl;
      }).catch(err=>{
        console.log(err,"拍照异常");
        that.msg.Alert(app.ERRORMESSAGE);
      });
    }else{
      let quality:any ={"quality":app.quality||15} ;//拍照照片压缩比例
      that.nativeService.getCameraPicture(quality).then((data)=>{
        let url = "data:image/jpeg;base64," + data;
        that.nativeService.AsyncCompressAccurately(url,1,200).then((body)=>{
          let _obj = {url:url,name:body.Status[0].FileName};
          that.imgUrlArr[i]["childImgUrl"].push(_obj);
          let submitImgUrl = "";
          that.imgUrlArr[i]["childImgUrl"].forEach((item)=>{
            if(submitImgUrl == ""){
              submitImgUrl += item.name;
            }else{
              submitImgUrl += ',' + item.name;
            }
          });
          that.baseService.arrayData[i]["photo"].value = submitImgUrl;
        });
      });
    }
  }

  async EditImg(i,j) {
    const that = this;
    const pageType = that.activaRouter.snapshot.paramMap.get('type');
    if(pageType=="view"){
      that.imgPreview(i,j);
      return;
    }
    const actionSheet = await this.actionSheet.create({
      // header: '',
      buttons: [{
        text: '预览',
        handler: () => {
          console.log('预览');
          that.imgPreview(i,j);
        }
      }, {
        text: '删除',
        handler: () => {
          // console.log("1008611");
          that.imgUrlArr[i]["childImgUrl"].splice(j, 1);
          let submitImgUrl = "";
          that.imgUrlArr[i]["childImgUrl"].forEach((item)=>{
            if(submitImgUrl == ""){
              submitImgUrl += item.name;
            }else{
              submitImgUrl += ',' + item.name;
            }
          })
          that.baseService.arrayData[i]["photo"].value = submitImgUrl;
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }
  imgPreview(i,j){
    let that = this;
    let url = [];
    that.imgUrlArr[i]["childImgUrl"].forEach(item=>{
      let u = null;
      if(item.url.indexOf("data:") > -1){
        u = item.url
      }else{
        u = item.url.trim().replace(app.SmallImageType,app.BigImageType);
      }
      url.push(u);
    })
    let ImgPreview = {
      imgUrl: url,
      index: j
    }
    that.com.setHistoryUrl();
    // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
    // that.router.navigate(["/tabs/contact/ImgPreview"]);
    that.com.Go("/tabs/contact/ImgPreview/"+that.com.getNowDatetime,{ImgPreview: JSON.stringify(ImgPreview)})
    // that.router.navigate(["/tabs/contact/ImgPreview/"+that.com.getNowDatetime], {
    //   queryParams: {
    //     ImgPreview: JSON.stringify(ImgPreview)
    //   }
    // });
  }

  priceChange(e,i){
    
    let val = e.target.value;
    const code =/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
    if(val && (!code.test(val) || val.length > 12)){
      this.baseService.arrayData[i]['price'].value = null;
      this.msg.Alert("价格填写有误！");
    }
  }


}